import React, { useState, useRef, useEffect } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISelect from 'components/selectbox/UISelect';
import codeDataStore from "common/codedata/store/CodeDataStore";
import { CodeData } from "common/codedata/source/CodeDataSource";
import ModalPopup from 'components/modal/';
import UIUtils from "utils/UIUtils";
import paramStore from "common/page/store/ParamStore";
import StringUtil from "utils/StringUtil";
function ContentsContainer() {
	const location = useLocation();
	let receivedData = (location.state as any)?.data;
	const history = useHistory();	
/*
  	const [StartDate, setStartDate] = useState(() => {
    	const currentYear = new Date().getFullYear();
    	return new Date(currentYear, 0, 1);
  	});
	const [EndDate, setEndDate] =useState(new Date());
*/
	const [StartDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [EndDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	
	const [totalRowCnt, setTotalRowCnt] = useState(0);
	const [showRowCnt, setShowRowCnt] = useState(20); //기본 row count
	const [SUB_YN, setSUB_YN] = useState('');
	const [BIZ_CD, setBIZ_CD] = useState('');
	const [BIZ_SHORT_NM, setBIZ_SHORT_NM] = useState<CodeData[]>();
	const [PAY_REQ_STS_CD, SetPAY_REQ_STS_CD] = useState('');
	const [TSK_NM, setTSK_NM] = useState('');
	const [SEARCH, setSEARCH] = useState('');
	const [SEARCH_VALUE, setSEARCH_VALUE] = useState('');

	const [SEARCH_DATE_OPTION, setSEARCH_DATE_OPTION] = useState('PAY_REG_DATE');
	
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [divCd,setDivCd] = useState('01');
	const [ApprovalLine, setApprovalLine] = useState('');
	const [ApprovalLine_S, setApprovalLine_S] = React.useState<CodeData[]>();
	const [SAN_NM, setSAN_NM] = useState('');
	const [REG_PERSON_ID, setREG_PERSON_ID] = useState('');
	const [REG_PERSON_NM, setREG_PERSON_NM] = useState('');
	const [REG_LOGIN_NM, setREG_LOGIN_NM] = useState('');
	const [MEMO, setMEMO] = useState('');	
	const [dateNum,setDateNum] = useState(0); 
	//let searchParams = useRef<any>({});
	//const PayListModel = new PayListSearch();
	const paramJson = useRef<string>("");
	
    //let SheetData = {};
    //let totalCnt = useRef<number>(0);
	//let defaultRowCnt = 20;
	//let rowCnt = useRef<number>(20);
	let pageNum = useRef<number>(1);
	
	const rowCnt = useRef<string>("20");
	const totalCnt = useRef<string>("");
	
	var ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,
				"CustomScroll": 3,
				"Height": "759px",
				         		
			},
			
			"Def": {
			    "Row": {
			      "CanFormula": true,
			      "CalcOrder": "chkType,chkVisible",
		    	},
    		},			

			"Cols": [
	            {"Header": "NO",			"Type": "Int",	"Name": "SEQ",					"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 50},
	            {
					"Header": {
						"Value": "",
						"HeaderCheck": 1, //헤더(Header)에 체크박스 생성
						"IconAlign": "Center" //체크박스 가운데 정렬
					},
					"Type" : "Bool",
					"Name": "chk",
					"RelWidth": 1,
					"Align": "Center",
					"CanEdit": 1, 
					"MinWidth": 80,
					"BoolIcon": 4,
					TypeFormula:function(fr){
						if(fr.Row["SUB_YN"] !== "Y" || fr.Row["PAY_REQ_STS_CD"] !== "F"){
							return "Text";
				      	}
					},					
					VisibleFormula:function(fr){
						if(fr.Row["SUB_YN"] !== "Y" || fr.Row["PAY_REQ_STS_CD"] !== "F"){
							return 0;
				      	}
					}					
				},
	            {"Header": "제출여부",			"Type": "Text",	"Name": "SUB_YN_DISP",			"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 80},
	            {
					"Header": "진행상태",
	            	"Type": "Html",
	            	"Name": "PAY_REQ_STS_CD",
	            	"RelWidth": 1,
	            	"Align": "center",
	            	"CanEdit": "0", 
	            	"MinWidth": 80,
	            	"Format": {
						'A':'<label class="badge badge-22 blue">신청</label>',
						'B':'<label class="badge badge-22 skyblue">접수중</label>',
						'C':'<label class="badge badge-22 yellow">수정요청</label>',
						'D':'<label class="badge badge-22 red">반려</label>',
						'F':'<label class="badge badge-22 green">최종접수</label>',
						'H':'<label class="badge badge-22 gray">결재중</label>',	
						'G':'<label class="badge badge-22 black">집행완료</label>',
											
					}, 
	            },
	            {"Header": "과제명",			"Type": "Text",	"Name": "TSK_NM",				"RelWidth": 2,	"Align": "left",	"CanEdit": 0, "MinWidth": 200},
	            {"Header": "과제신청번호",		"Type": "Text",	"Name": "TSK_REQ_NO_DISP",		"RelWidth": 1, 	"Align": "Center",	"CanEdit": 0, "MinWidth": 100},
				{"Header": "출연사업","Type": "Text","Name": "BIZ_NM","RelWidth": 1,"Align": "Center" ,"CanEdit": "0", "MinWidth": 80},
	            {"Header": "출연기업명",		"Type": "Text",	"Name": "CORP_NM",				"RelWidth": 1,	"Align": "left",	"CanEdit": 0, "MinWidth": 120},
	            {"Header": "담당자",			"Type": "Text",	"Name": "PERSON_NM",			"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 70},
	            {"Header": "지급신청번호",		"Type": "Text",	"Name": "PAY_REQ_NO_DISP",		"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 120},
	            {"Header": "신청일",			"Type": "Text",	"Name": "PAY_REQ_DATE",			"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 100},
	            {"Header": "제출일",			"Type": "Text",	"Name": "SUB_DATE",				"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 100},
	            {"Header": "집행완료일",		"Type": "Text",	"Name": "PAY_COMPL_DATE",		"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 100},
	            {"Header": "지급신청금액",		"Type": "Int",	"Name": "TOT_AMT",				"RelWidth": 1,	"Align": "Right",	"CanEdit": 0, "MinWidth": 120, "Format": "#,###"},
	            {"Header": "집행금액",			"Type": "Int",	"Name": "NOR_AMT",				"RelWidth": 1,	"Align": "Right",	"CanEdit": 0, "MinWidth": 120, "Format": "#,###"},
	            {"Header": "미집행금액",		"Type": "Int",	"Name": "NON_AMT",				"RelWidth": 1,	"Align": "Right",	"CanEdit": 0, "MinWidth": 120, "Format": "#,###"},
	            {"Header": "지급종결",			"Type": "Text",	"Name": "CLO_YN",				"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 100},
	            {"Header": "지원기업수",		"Type": "Int",	"Name": "SUPP_CORP_CNT",		"RelWidth": 1,	"Align": "Right",	"CanEdit": 0, "MinWidth": 80, "Format": "#,##0"},
	            {"Header": "수행기업수",		"Type": "Int",	"Name": "PERF_CNT",				"RelWidth": 1,	"Align": "Right",	"CanEdit": 0, "MinWidth": 80, "Format": "#,##0"},
	            {"Header": "세금계산서\n첨부여부","Type": "Text",	"Name": "TAXBILL_YN_DISP",		"RelWidth": 1,	"Align": "Center",	"CanEdit": 0, "MinWidth": 80},
	            {"Header": "SUB_YN",		"Type": "Text",	"Name": "SUB_YN",				"RelWidth": 0, 	Visible : 0},
	            {"Header": "TSK_REQ_NO",	"Type": "Text",	"Name": "TSK_REQ_NO",			"RelWidth": 0, 	Visible : 0},
	            {"Header": "PAY_REQ_NO",	"Type": "Text",	"Name": "PAY_REQ_NO",			"RelWidth": 0, 	Visible : 0},
	            
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				onClickSearch('init');

			},
			
			onDblClick:function(evtParam){
				//onClickDetail();
				var sheet = evtParam.sheet;
				var row = sheet.getFocusedRow();
				sheet.selectRow(row, 1);
				
				if(evtParam.kind != "Header"){
					var vPAY_REQ_NO = row["PAY_REQ_NO"];
					var vPAY_REQ_STS_CD = row["PAY_REQ_STS_CD"];
					var vSUB_YN = row["SUB_YN"];
					var vPageNum = '1405';
					
					let dataToSend = {vPAY_REQ_NO, vPAY_REQ_STS_CD, vSUB_YN, vPageNum};
					paramStore.setParam("adm1406", dataToSend);

					history.push({
						pathname: 'adm1406',
						//state: { data: dataToSend }
					});
				}
				
		    },
			
			onRenderFinish  :function(evtParam){
				if(receivedData !== undefined ){
					if(receivedData.PARAM_DATA !== undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
						pageMove(receivedData.PARAM_PAGE);
					}
				}
			},
					    
			onAfterGotoPage:function (evtParam) {
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				pageNum.current = page; //페이지 번호 저장용
				paramSetting();
				
		        //@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex(page);
				}
			},	
			
			onAfterSort:function(evtParam){
				var sheet = evtParam.sheet;
				
				sheet.goToPageByIndex(1);
				if(sheet.getShownRows().length !== 0){
					sheet.focus(sheet.getShownRows()[0], "SEQ");
				}
			},
            onBeforeDataLoad:function (evtParam) {
                // 조회 후 로딩 전 발생 이벤트
                var d = evtParam.data;
                var _data;

                // 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
                if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
                _data = JSON.stringify(d.slice(0, 20), null, 2);
                _data += _data.substring(0, _data.length - 1) + '...\n]';
                } else {
                _data = JSON.stringify(d, null, 2);
                }

            },

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			if(receivedData !== undefined ){
				if(receivedData.PARAM_DATA !== undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
					options.Cfg.PageLength = receivedData.PARAM_ROW_CNT;
				}
			}

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'tb_cfms_pay_req', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
				
			});
			
			//@ts-ignore
			window.currentPage = -1;
			
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.Main_sheet.down2Excel({fileName: "지급신청현황_"+today+".xlsx", SheetDesign:3, excelRowHeight:16.5, excelFontSize:10, downCols: "Visible"});
		},
		
		'data':[]
	}
	

	const paramSetting = () => {
		let PARAM_DATA = paramJson.current;
		let PARAM_PAGE = pageNum.current;
		let PARAM_ROW_CNT = rowCnt.current;
		let dataToSend = {PARAM_DATA, PARAM_PAGE, PARAM_ROW_CNT};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1405',
			state: { data: dataToSend }
		});
	}


	function dateToStr(dateText) {
		if(dateText == null) return '';
		let year = dateText.substring(0,4);
		let month = dateText.substring(4,6);
		let day = dateText.substring(6,8);

		return year+'-'+month+'-'+day;
	}

	const setSearchData = (type:string) => {
		let param:any = {};
		param = {
			"PAY_REQ_DATE_S" : DateUtil.toDateFormat(StartDate, "YYYYMMDD"),
			"PAY_REQ_DATE_E" : DateUtil.toDateFormat(EndDate, "YYYYMMDD"),
			"BIZ_CD": BIZ_CD,
			"PAY_REQ_STS_CD" : PAY_REQ_STS_CD,
			"SUB_YN" : SUB_YN,
			"TSK_NM" : TSK_NM,
			"SEARCH" : SEARCH,
			"SEARCH_VALUE" : SEARCH_VALUE,
			"SEARCH_DATE_OPTION" : SEARCH_DATE_OPTION
		};

		if(type === 'init'){
			//넘어온 파라미터 바인딩
			if(receivedData !== undefined && receivedData.PARAM_DATA !== undefined){
				param = JSON.parse(receivedData.PARAM_DATA);
				if(param.PAY_REQ_DATE_S !== '') setStartDate(new Date(dateToStr(param.PAY_REQ_DATE_S)));
				if(param.PAY_REQ_DATE_E !== '') setEndDate(new Date(dateToStr(param.PAY_REQ_DATE_E)));
				if(param.BIZ_CD !== '') setBIZ_CD(param.BIZ_CD);
				if(param.PAY_REQ_STS_CD !== '') SetPAY_REQ_STS_CD(param.PAY_REQ_STS_CD);
				if(param.SUB_YN !== '') setSUB_YN(param.SUB_YN);
				if(param.TSK_NM !== '') setTSK_NM(param.TSK_NM);
				if(param.SEARCH !== '') setSEARCH(param.SEARCH);
				if(param.SEARCH !== '') setSEARCH(param.SEARCH);
				if(param.SEARCH_DATE_OPTION !== '') setSEARCH_DATE_OPTION(param.SEARCH_DATE_OPTION);
				rowCnt.current = receivedData.PARAM_ROW_CNT;
				setShowRowCnt(Number(rowCnt.current));
			}
		} else {
			pageNum.current = 1;
		}
		paramJson.current = JSON.stringify(param);

		paramSetting();

		return param;
	}		


    async function onClickSearch(sAction:string) {
		let param = {};
		param = setSearchData(sAction);

		const response:any = await CommonUtil.execute({
            url:"adm_1405_r001",
			data: param			
        })
    	.then((response: any) => {
			if(sAction ==='init'){
				var delItems: {code: string; name: string;}[] = [];
				// @ts-ignore
				var delItem: {code: string; name: string;} = {};
		
		    	// @ts-ignore
				var rows = response.REC;
				for (var i = 0; i < Object.keys(response.REC).length; i++) {
			        delItem = {
			            code: rows[i]["CODE"],
			            name: rows[i]["NAME"],
			        };
		 	    	delItems.push(delItem);
			  	}
				// @ts-ignore
				setBIZ_SHORT_NM(delItems);
			}
			        		
			totalCnt.current = Object.keys(response.REC2).length+'';
			setTotalRowCnt(Object.keys(response.REC2).length);
	
			ib.data = response.REC2;

	        // @ts-ignore
	        Main_sheet.loadSearchData(response.REC2);
			// @ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(Main_sheet.getPageIndex(Main_sheet.getFocusedPage()) + 1); // 페이지 초기화	
					
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}
	
    async function SetDate(value){
	    const newEndDate = new Date();
	    setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
	    const newStartDate = new Date(newEndDate);
	    newStartDate.setDate(newEndDate.getDate() - value);
	    setStartDate(newStartDate);  // 시작 날짜를 조정
    }

    /*
    async function onClickSearch(sAction:string, searchData:any) {
		let param = {};
		
		if(searchData !== ''){
			param = searchData;
		} else {
			param = {
				"PAY_REQ_DATE_S" : DateUtil.toDateFormat(StartDate, "YYYYMMDD"),
				"PAY_REQ_DATE_E" : DateUtil.toDateFormat(EndDate, "YYYYMMDD"),
				"BIZ_CD": BIZ_CD,
				"PAY_REQ_STS_CD" : PAY_REQ_STS_CD,
				"SUB_YN" : SUB_YN,
				"TSK_NM" : TSK_NM,
				"SEARCH" : SEARCH,
				"SEARCH_VALUE" : SEARCH_VALUE,
			}			
			//검색조건을 해당 페이지에 다시 넣어준다.
			searchParams.current = param;
			let searchData = searchParams.current;
			let searchPageNum = 1;   //조회시는 무조건 페이지 번호는 1
			let dataToSend = { searchData , searchPageNum }
			
			history.push({ 
				pathname: './adm1405', 
				state: { data: dataToSend }
			});
			
			receivedData = dataToSend;  //검색조건을 다시 넣어준다.

		}

		
		const response:any = await CommonUtil.execute({
            url:"adm_1405_r001",
			data: param			
        })
    	.then((response: any) => {
			if(sAction ==='init' || searchData !== ''){
				var delItems: {code: string; name: string;}[] = [];
				// @ts-ignore
				var delItem: {code: string; name: string;} = {};
		
		    	// @ts-ignore
				var rows = response.REC;
				for (var i = 0; i < Object.keys(response.REC).length; i++) {
			        delItem = {
			            code: rows[i]["CODE"],
			            name: rows[i]["NAME"],
			        };
		 	    	delItems.push(delItem);
			  	}
				// @ts-ignore
				setBIZ_SHORT_NM(delItems);
			}
			        		
			totalCnt.current = Object.keys(response.REC2).length;
			setTotalRowCnt(totalCnt.current);
	
			SheetData = response.REC2;
			// @ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        Main_sheet.loadSearchData(SheetData);
	        //if( searchData !== ''){
				// @ts-ignore
				//makePageIndex(pageNum.current); // 페이지 초기화	
			//} else {
				// @ts-ignore
				makePageIndex(Main_sheet.getPageIndex(Main_sheet.getFocusedPage()) + 1); // 페이지 초기화	
			//}	
					
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}
	*/
	/*
    async function onClickDetail() {
		// @ts-ignore
		var row = Main_sheet.getFocusedRow();
		var vPAY_REQ_NO = row["PAY_REQ_NO"];
		var vPAY_REQ_STS_CD = row["PAY_REQ_STS_CD"];
		var vSUB_YN = row["SUB_YN"];
		var sPAY_REQ_DATE_S = StartDate;
		var sPAY_REQ_DATE_E = EndDate;
		var sBIZ_CD = BIZ_CD;
		var sPAY_REQ_STS_CD = PAY_REQ_STS_CD;
		var sSUB_YN = SUB_YN;
		var sTSK_NM = TSK_NM;
		var sSEARCH = SEARCH;
		var sSEARCH_VALUE = SEARCH_VALUE;
		console.log("onClickDetail() = " + SEARCH_VALUE);
		
		//PayListModel.setStartDate(StartDate);
		//PayListModel.setStartDate(EndDate);
		
	    let dataToSend = {vPAY_REQ_NO, vPAY_REQ_STS_CD, vSUB_YN, sPAY_REQ_DATE_S, sPAY_REQ_DATE_E, sBIZ_CD, sPAY_REQ_STS_CD, sSUB_YN, sTSK_NM, sSEARCH, sSEARCH_VALUE};
	    paramStore.setParam("adm1406", dataToSend);
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
			pathname: 'adm1406',
	    });

    };   
	*/

	async function onClickApprOpen(){
		var count = 0;
		// @ts-ignore
		var rows = Main_sheet.getDataRows();
		
		for (var i = 0; i < rows.length; i++) {
			/*
			if ( rows[i]["chk"] ===  1 && (rows[i]["PAY_REQ_STS_CD"] !== "F" || rows[i]["SUB_YN"] !== "Y") ){
				UIUtils.alert('최종접수, 제출 상태인 지급건만 결재상신이 가능합니다.').then();
				return;
			}
			*/
			if ( rows[i]["chk"] ===  1 && rows[i]["PAY_REQ_STS_CD"] === 'F' && rows[i]["SUB_YN"] === 'Y'){	
				count++;
			}
		}
		
		if( count === 0 ){
			UIUtils.alert('처리할 항목을 선택하세요.').then();
			return;
		}
		
		
		var delItems: { PAY_REQ_NO: string; }[] = [];
		// @ts-ignore
		var delItem:  { PAY_REQ_NO: string; } = {};
		
		for (var i = 0; i < rows.length; i++) {
			if ( rows[i]["chk"] ===  1){
		        delItem = {
		            PAY_REQ_NO: rows[i]["PAY_REQ_NO"],
				}
				delItems.push(delItem);
			}
		}
		
		var same = false;
		 
		const response:any = await CommonUtil.execute({
			url:"adm_1405_r002",
			data: { 
				"REC" : delItems,
			}
		})
    	.then((response: any) => {
			if(response.count > 0){
				same = true;				
			}
			
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 			        

    	if (same) {
			if(await UIUtils.confirm('사업자번호, 계좌번호, 금액이 동일한 건이 존재합니다. 동일거래 여부 확인 후 결재상신 부탁드립니다.')){
				setModalIsOpen(true);		
			} 
		} else {
			setModalIsOpen(true);
		}
		
	}

	
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr =  Number(totalCnt.current) // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr /  Number(page)); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
	}
	
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	const pageMove = function (cPage:number) {
		// @ts-ignore
		Main_sheet.goToPageByIndex(cPage);
		//receivedData = undefined;
	}
	
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			receivedData.PARAM_ROW_CNT = e.target.value;
			rowCnt.current = e.target.value;
			pageNum.current = 1;
			
		   	// @ts-ignore
		   	IBSheet.disposeAll(true);		  
		   	ib.init.Cfg.PageLength = e.target.value;
		   	ib.create();
		   
		}
	};
	
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch('search');
		}
	}
		    	
	useEffect(() => {
		codeDataStore.read("[PRSC]");

        // @ts-egnore
		ib.create();
		/*
		if( receivedData !== undefined ){
			if(receivedData.searchData.PAY_REQ_DATE_S !== undefined && receivedData.searchData.PAY_REQ_DATE_S !== ''){
				const startDate = DateUtil.stringToDate(receivedData.searchData.PAY_REQ_DATE_S,'YYYYMMDD');
				setStartDate(startDate!);
			}
			
			if(receivedData.searchData.PAY_REQ_DATE_E !== undefined && receivedData.searchData.PAY_REQ_DATE_E !== ''){
				const endDate = DateUtil.stringToDate(receivedData.searchData.PAY_REQ_DATE_E,'YYYYMMDD');
				setEndDate(endDate!);
			}

			setBIZ_CD(StringUtil.defaultString(receivedData.searchData.BIZ_CD));
			SetPAY_REQ_STS_CD(StringUtil.defaultString(receivedData.searchData.PAY_REQ_STS_CD));
			setSUB_YN(StringUtil.defaultString(receivedData.searchData.SUB_YN));
			setTSK_NM(StringUtil.defaultString(receivedData.searchData.TSK_NM));
			setSEARCH(StringUtil.defaultString(receivedData.searchData.SEARCH));
			setSEARCH_VALUE(StringUtil.defaultString(receivedData.searchData.SEARCH_VALUE));		

			onClickSearch('search', receivedData.searchData);		
			
		}
		*/						

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }
        
    },[])
    
	let LeftSheetData = {};
	let RightSheetData = {};
	
	var ib_modal = ib_modal||{};
 	ib_modal = {
		//시트 초기화 구문
		'init':{
			"LeftSheetInit": {
				//공통기능 설정 부분
				"Cfg": {
		            "SearchMode": 0,
		            "CanSort": true,
		            "CanColMove": false,
		            "CanColResize": false,
		            "Height": "446px",
		            "InfoRowConfig": {
		                "Visible": false
		            },
				},
				//중앙(메인) 컬럼 설정
			    "Cols": [
					{"Header": "이름",	"Type": "Text","Name": "PERSON_NM",		"Align": "Center",	"CanEdit": 0,"RelWidth": 1},
					{"Header": "직급",	"Type": "Text","Name": "POSI_NM",		"Align": "Center",	"CanEdit": 0,"RelWidth": 1},
					{"Header": "부서",	"Type": "Text","Name": "DEPT_NM",		"Align": "left",	"CanEdit": 0,"RelWidth": 1.5},
					{"Header": "아이디",	"Type": "Text","Name": "LOGIN_NM",		"Align": "left",	"CanEdit": 0,"RelWidth": 1},
					{"Header": "LIMIT_AMOUNT",	"Type": "Int","Name": "LIMIT_AMOUNT",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "AMOUNT_RANGE",	"Type": "Text","Name": "AMOUNT_RANGE",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "PERSON_ID",		"Type": "Text","Name": "PERSON_ID",		"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{
						"Header": "담당",
						"Type": "Enum",
						"Name": "APPROVAL_ROLE", 
						"RelWidth": 1,
						"Required": 1,
						"CanEdit": 1,
						"IconAlign": "Center",
						"Enum": "|검토자|협조자|감사자|결재자",
						"EnumKeys": "|1|2|3|4",
						Visible : 0
					}					
				]
			},
			"RightSheetInit": {
				"Cfg": {
		            
		            "SearchMode": 0,
		            "CanSort": false,
		            "CanColMove": false,
		            "CanColResize": false,
		            "Height": "282px",
		            "InfoRowConfig": {
		                "Visible": false
		            },
		            "ZIndex": 900, //결재선 프레임 zindex가 900입니다. 그 이상 설정해주어야 합니다.
            
				},
			    
				"Cols": [
					{"Header": "이름",	"Type": "Text","Name": "PERSON_NM",		"Align": "Center",	"CanEdit": 0,	"RelWidth": 1},
					{"Header": "직급",	"Type": "Text","Name": "POSI_NM",		"Align": "Center",	"CanEdit": 0,	"RelWidth": 1},
					{"Header": "부서",	"Type": "Text","Name": "DEPT_NM",		"Align": "left",	"CanEdit": 0,	"RelWidth": 1.5},
					{"Header": "아이디",	"Type": "Text","Name": "LOGIN_NM",		"Align": "let",	"CanEdit": 0,	"RelWidth": 1},
					{"Header": "LIMIT_AMOUNT",	"Int": "Text","Name": "LIMIT_AMOUNT",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "AMOUNT_RANGE",	"Type": "Text","Name": "AMOUNT_RANGE",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "PERSON_ID",		"Type": "Text","Name": "PERSON_ID",		"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{
						"Header": {"Value": "담당" ,"Color": "#FFDFDF"},	
						"Type": "Enum",
						"Name": "APPROVAL_ROLE", 
						"RelWidth": 1,
						"Required": 1,
						"CanEdit": 1,
						"IconAlign": "Center",
						"Enum": "|검토자|협조자|감사자|결재자",
						"EnumKeys": "|1|2|3|4"
					}
				]
			}     

		},
		//시트 이벤트
		'event':{

			onAfterRowMoveToSheet:function (evtParam) {
				console.log('onAfterRowMoveToSheet 이벤트 발생:\n' + evtParam.sheet.id + '시트에서 ' + evtParam.tosheet.id + '로 행이 이동하였습니다.');
			},
			  onRenderFirstFinish:function (evtParam) {
					//초기 데이터 로딩
					initSheet_modal();
			},
			onAfterRowCopy:function(evtParam){
				if(evtParam.source.Deleted === true) {
					UIUtils.alert('지워진 행은 복사할 수 없습니다.').then();
					//evtParam.sheet.showMessageTime('지워진 행은 복사할 수 없습니다.', 800);
					return true;
				}
			},
			onDblClick:function(evtParam){     //더블 클릭시 행 카피 가능하게 처리
				var sheet = evtParam.sheet;
				if(sheet.id === "LeftSheet"){     //왼쪽 시트일경우만 copy가능
					/** 행 추가 전에 중복 데이터 확인 처리 */
					//@ts-ignore
					if(RightSheet.getTotalRowCount() > 6){
						UIUtils.alert('최대 7명까지만 결재순위에 등록할 수 있습니다.').then();
						//evtParam.sheet.showMessageTime(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다.', 800);
						return;						
					}
					//@ts-ignore
					if(RightSheet.getTotalRowCount() > 0){
						//@ts-ignore
						var rightRows = RightSheet.getDataRows(); //우측 시트값 전체 데이터 조회
						//@ts-ignore
						var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
						fRows.APPROVAL_ROLE = 1;
						for(var i=0; i<rightRows.length; i++){
							if(fRows.LOGIN_NM === rightRows[i].LOGIN_NM){
								//alert(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다');
								UIUtils.alert('동일한 ID가 존재합니다.').then();
								//evtParam.sheet.showMessageTime(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다.', 800);
								return;
							}
						}
					}

					//@ts-ignore
					var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
					fRows.APPROVAL_ROLE = 1;
					//@ts-ignore
					RightSheet.copyRow({row: LeftSheet.getFocusedRow()});

				   	//@ts-ignore
					RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
					//@ts-ignore
					LeftSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
				}
				
				
				
			},
		},
		//시트객체 생성
		'create':function () {
			var options = this.init.LeftSheetInit;
	
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'LeftSheet', // 생성할 시트의 id
				el: 'LeftSheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: LeftSheetData, // 생성될 시트의 정적데이터
			});
	
			var options2 = this.init.RightSheetInit;

			//@ts-ignore
			options2.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'RightSheet', // 생성할 시트의 id
				el: 'RightSheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options2, // 생성될 시트의 속성
				data: RightSheetData, // 생성될 시트의 정적데이터
			});
	
		},
		

	}	
	
    async function initSheet_modal() {
		let param = {
			"SEARCH_DIV_CD": divCd,
			"SEARCH_TEXT": searchText,
		};
		
		const response:any = await CommonUtil.execute({
            url:"adm_7000_r002",
            data: param
        })
    	.then((response: any) => {
			setREG_PERSON_ID(response.REG_PERSON_ID);
			setREG_PERSON_NM(response.REG_PERSON_NM);
			setREG_LOGIN_NM(response.REG_LOGIN_NM);
	        
			var delItems: {code: string; name: string;}[] = [];
			// @ts-ignore
			var delItem: {code: string; name: string;} = {};
	
	    	// @ts-ignore
			var rows = response.REC2;
			for (var i = 0; i < Object.keys(response.REC2).length; i++) {
		        delItem = {
		            code: rows[i]["CODE"],
		            name: rows[i]["NAME"],
		        };
				
	 	    	delItems.push(delItem);
		  	}        
	        
			setApprovalLine_S(delItems);
		
			var data_modal = response.REC;
	
		   	//데이터 처리
		   	LeftSheetData = data_modal;
		   	// @ts-ignore	
		   	LeftSheet.loadSearchData(data_modal);  //data 로딩 처리 
		   	// @ts-ignore	
		   	LeftSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함				
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});
       
	}
		
    //검색
    async function onClickSearch_modal() {
		let param = {
			"SEARCH_DIV_CD": divCd,
			"SEARCH_TEXT": searchText,
		};

		const response:any = await CommonUtil.execute({
            url:"adm_7000_r001",
            data: param
        })
    	.then((response: any) => {
			let data_modal = response.REC;
		   //데이터 처리
		   //LeftSheetData = data_modal;
		   // @ts-ignore	
		   LeftSheet.loadSearchData(data_modal);  //data 로딩 처리 
		   // @ts-ignore	
		   LeftSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	   
    }; 


    async function valueChangedApprLine_modal(value) {
		console.log('value = ' + value);
		if ( value === '' ){
			setApprovalLine(value);
			setSAN_NM('');
			console.log('ok valueChangedApprLine_modal value = ' + value);
			// @ts-ignore	
			RightSheet.reloadData();
			return;
							
		} else if ( value === '선택' ){
			return;
							
		} else {
			setApprovalLine(value);
			console.log('else valueChangedApprLine_modal value = ' + value);
			let param = {
				"APPR_ID": value,
			};
			
			const response:any = await CommonUtil.execute({
	            url:"adm_7000_r003",
	            data: param
	        })
	    	.then((response: any) => {
				let data_modal = response.REC;
			
				//데이터 처리
				RightSheetData = data_modal;
				// @ts-ignore
				RightSheet.loadSearchData(data_modal);  //data 로딩 처리 
				// @ts-ignore	
				RightSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	
			   	setSAN_NM(response.SAN_NM);
				return;
	    	}).catch((error) => {
	        	CommonUtil.showAxiosError(error);
	        	return;
	        	
	    	});	   			
		}
	   		
	}	
	
    async function onClickSave_modal() {
		// @ts-ignore
		var delItems: { REG_LOGIN_NM: string; REG_PERSON_ID: string; SAN_PERSON_NM: string; SAN_LOGIN_NM: string; SAN_PERSON_ID: string; APPROVAL_ROLE: string; APPR_STAP_NO: string; LAST_SAN_YN: string; SAN_NM: string;}[] = [];
		// @ts-ignore
		var delItem:  { REG_LOGIN_NM: string; REG_PERSON_ID: string; SAN_PERSON_NM: string; SAN_LOGIN_NM: string; SAN_PERSON_ID: string; APPROVAL_ROLE: string; APPR_STAP_NO: string; LAST_SAN_YN: string; SAN_NM: string;} = {};


    	// @ts-ignore
		if( RightSheet.getTotalRowCount() < 1 ){
			UIUtils.alert('선택된 결재순위가 없습니다.').then();
			return;
		} 
		
		// @ts-ignore
		var rows = RightSheet.getDataRows();
		if ( SAN_NM === ''){
			var vSAN_NM = "";
			
			for (var i = 0; i < rows.length; i++) {
				vSAN_NM = vSAN_NM + rows[i]["PERSON_NM"];	
				if ( i !== rows.length - 1) {
					vSAN_NM = vSAN_NM + ' > ';
				}
			}
			setSAN_NM(vSAN_NM);
			var sSAN_NM = vSAN_NM;		
		} else {
			var sSAN_NM= SAN_NM;
		}			
				
        delItem = {
            APPR_STAP_NO: "0",
			REG_LOGIN_NM : REG_LOGIN_NM,
			REG_PERSON_ID : REG_PERSON_ID,
            SAN_NM: sSAN_NM,
            APPROVAL_ROLE: "0",
            SAN_LOGIN_NM: REG_LOGIN_NM,
            SAN_PERSON_ID: REG_PERSON_ID,
            SAN_PERSON_NM: REG_PERSON_NM,
            LAST_SAN_YN: "N",
        };		
		delItems.push(delItem);		
			
		for (var i = 0; i < rows.length; i++) {
			if ( i === rows.length - 1){
		        delItem = {
		            APPR_STAP_NO: String(i+1),
					REG_LOGIN_NM : REG_LOGIN_NM,
					REG_PERSON_ID : REG_PERSON_ID,
		            SAN_NM: sSAN_NM,
		            APPROVAL_ROLE: rows[i]["APPROVAL_ROLE"],
		            SAN_LOGIN_NM: rows[i]["LOGIN_NM"],
		            SAN_PERSON_ID: rows[i]["PERSON_ID"],
		            SAN_PERSON_NM: rows[i]["PERSON_NM"],
		            LAST_SAN_YN: "Y",
		        };
			} else {
		        delItem = {
		            APPR_STAP_NO: String(i+1),
					REG_LOGIN_NM : REG_LOGIN_NM,
					REG_PERSON_ID : REG_PERSON_ID,
		            SAN_NM: sSAN_NM,
		            APPROVAL_ROLE: rows[i]["APPROVAL_ROLE"],
		            SAN_LOGIN_NM: rows[i]["LOGIN_NM"],
		            SAN_PERSON_ID: rows[i]["PERSON_ID"],
		            SAN_PERSON_NM: rows[i]["PERSON_NM"],
		            LAST_SAN_YN: "N",
		        };				
			}			
			
 	    	delItems.push(delItem);
			      	
	  	}		

		if ( delItems.length > 0 ){
			var delItems2: {code: string; name: string;}[] = [];
			// @ts-ignore
			var delItem2: {code: string; name: string;} = {};

		    if(await UIUtils.confirm('저장하겠습니까?')){
				if( ApprovalLine === '' ){
					const response:any = await CommonUtil.execute({
						url:"adm_7000_c004",
						data: { "REC" : delItems }
					})
			    	.then((response: any) => {
				    	// @ts-ignore
						var rows = response.REC2;
						console.log(response.REC2);
						for (var i = 0; i < Object.keys(response.REC2).length; i++) {
					        delItem2 = {
					            code: rows[i]["CODE"],
					            name: rows[i]["NAME"],
					        };
				 	    	delItems2.push(delItem2);
					  	}
				        
			            UIUtils.alert('정상처리되었습니다.').then();
						setApprovalLine_S(delItems2);
		            	valueChangedApprLine_modal(response.APPR_ID);
			            return;
						
			    	}).catch((error) => {
			        	CommonUtil.showAxiosError(error);
			        	return;
			        	
			    	});	 			        
										
				} else {
					const response:any = await CommonUtil.execute({
						url:"adm_7000_u006",
						data:  { 
							"APPR_ID" : ApprovalLine, 
							"REC" : delItems
						}
					})
			    	.then((response: any) => {
						var rows = response.REC2;
						console.log(response.REC2);
						for (var i = 0; i < Object.keys(response.REC2).length; i++) {
					        delItem2 = {
					            code: rows[i]["CODE"],
					            name: rows[i]["NAME"],
					        };
							
				 	    	delItems2.push(delItem2);
					  	}
				        
			            UIUtils.alert('정상처리되었습니다.').then();
						setApprovalLine_S(delItems2);
		            	valueChangedApprLine_modal(response.APPR_ID);
			            return;

			    	}).catch((error) => {
			        	CommonUtil.showAxiosError(error);
			        	return;
			        	
			    	});	 			        
				}
					
			}
		} 
		
	}


	async function onClickDelete_modal() {
		if( ApprovalLine === '' ){
			UIUtils.alert('선택된 결재선이 없습니다.').then();
			return;
		} else {
		    if(await UIUtils.confirm('삭제하겠습니까?')){
				const response:any = await CommonUtil.execute({
					url:"adm_7000_d005",
					data: { "APPR_ID" : ApprovalLine }
				})
		    	.then((response: any) => {
					UIUtils.alert("삭제되었습니다.").then();
					var delItems2: {code: string; name: string;}[] = [];
					// @ts-ignore
					var delItem2: {code: string; name: string;} = {};
					
			    	// @ts-ignore
					var rows = response.REC;
					console.log(response.REC);
					for (var i = 0; i < Object.keys(response.REC).length; i++) {
				        delItem2 = {
				            code: rows[i]["CODE"],
				            name: rows[i]["NAME"],
				        };
						
			 	    	delItems2.push(delItem2);
				  	}
			        
					setApprovalLine_S(delItems2);
					setSAN_NM('');
					// @ts-ignore	
					RightSheet.reloadData();					
					return;

		    	}).catch((error) => {
		        	CommonUtil.showAxiosError(error);
		        	return;
		        	
		    	});	 			        
		
			}		
		}
		
	}
	
	async function onClickApprRegist_modal() {
    	// @ts-ignore
		if( RightSheet.getTotalRowCount() < 1 ){
			UIUtils.alert('선택된 결재순위가 없습니다.').then();
			return;
		} 
		
    	// @ts-ignore
		var Right_rows = RightSheet.getDataRows();
		if ( Right_rows[Right_rows.length - 1]["LIMIT_AMOUNT"] === '' || Right_rows[Right_rows.length - 1]["AMOUNT_RANGE"] === ''){
			UIUtils.alert('최종결재자의 한도금액이\n설정되지 않아 저장할 수 없습니다.\n시스템관리자에게 문의하시기 바랍니다.').then();
			return;			

		}
		
		var j = 0;

		for ( var i = 0; i < Right_rows.length; i++ ) {
			if ( Right_rows[i]["APPROVAL_ROLE"] === 4 || Right_rows[i]["APPROVAL_ROLE"] === '4' ){
				j = j + 1;	
			}
		}
		
		if ( j < 1) {
			UIUtils.alert('결재자가 존재하지 않습니다.').then();
			return;			
		}
		
		var amount_range = Right_rows[Right_rows.length - 1]["AMOUNT_RANGE"];
		var limit_amount = Right_rows[Right_rows.length - 1]["LIMIT_AMOUNT"];
		//console.log(amount_range);
		//console.log(limit_amount);
		
		// @ts-ignore
		var Main_rows = Main_sheet.getDataRows();
		
		if (amount_range === 2){
			for (var i = 0; i < Main_rows.length; i++) {
				if ( Main_rows[i]["chk"] ===  1){
					if ( Main_rows[i]["TOT_AMT"] >= 	limit_amount){
						UIUtils.alert('최종결재자의 한도금액이 초과되었습니다.\n최종결재자를 변경하시거나 시스템관리자\n에게 문의하시기 바랍니다.').then();
						return;			
					}
					
				}
			}
		} else {
			for (var i = 0; i < Main_rows.length; i++) {
				if ( Main_rows[i]["chk"] ===  1){
					if ( Main_rows[i]["TOT_AMT"] < limit_amount){
						UIUtils.alert('최종결재자의 한도금액 미만입니다.\n최종결재자를 변경하시거나 시스템관리자\n에게 문의하시기 바랍니다.').then();
						return;			
					}
				}
			}
		}
		
	    if(await UIUtils.confirm('선택한 내역에 대해 결재상신합니다.')){
			const newEndDate = new Date();
			
			// @ts-ignore
			var delItems: { REG_LOGIN_NM: string; REG_PERSON_ID: string; APPR_ID: string; SAN_LOGIN_NM: string; SAN_PERSON_ID: string; APPROVAL_ROLE: string; SAN_DATE: string; SAN_TIME: string; SAN_STS: string; APPR_STAP_NO: string; LAST_SAN_YN: string;}[] = [];
			// @ts-ignore
			var delItem:  { REG_LOGIN_NM: string; REG_PERSON_ID: string; APPR_ID: string; SAN_LOGIN_NM: string; SAN_PERSON_ID: string; APPROVAL_ROLE: string; SAN_DATE: string; SAN_TIME: string; SAN_STS: string; APPR_STAP_NO: string; LAST_SAN_YN: string;} = {};
		
			if ( SAN_NM === ''){
				var vSAN_NM = "";
				for (var i = 0; i < Right_rows.length; i++) {
					vSAN_NM = vSAN_NM + Right_rows[i]["PERSON_NM"];	
					if ( i !== Right_rows.length - 1) {
						vSAN_NM = vSAN_NM + ' > ';
					}
				}
				setSAN_NM(vSAN_NM);
				var sSAN_NM = vSAN_NM;		
			} else {
				var sSAN_NM= SAN_NM;
			}			
					
	        delItem = {
	            APPR_STAP_NO: "0",
	            APPR_ID : ApprovalLine,
				REG_LOGIN_NM : REG_LOGIN_NM,
				REG_PERSON_ID : REG_PERSON_ID,
	            APPROVAL_ROLE: "0",
	            SAN_STS : "1",
	            SAN_DATE : DateUtil.toDateFormat(newEndDate, "YYYYMMDD"),
	            SAN_TIME : DateUtil.toDateFormat(newEndDate, "HHmmss"),
	            SAN_LOGIN_NM: REG_LOGIN_NM,
	            SAN_PERSON_ID: REG_PERSON_ID,
	            LAST_SAN_YN: "N",
	        };		
			delItems.push(delItem);		
				
			var vMAX_LINE_NO = Right_rows.length;
			
			for (var i = 0; i < Right_rows.length; i++) {
				if ( i === Right_rows.length - 1){
			        delItem = {
			            APPR_STAP_NO: String(i+1),
			            APPR_ID : ApprovalLine,
						REG_LOGIN_NM : REG_LOGIN_NM,
						REG_PERSON_ID : REG_PERSON_ID,
			            APPROVAL_ROLE: Right_rows[i]["APPROVAL_ROLE"],
			            SAN_STS : "0",
			            SAN_DATE : '',
			            SAN_TIME : '',
			            SAN_LOGIN_NM: Right_rows[i]["LOGIN_NM"],
			            SAN_PERSON_ID: Right_rows[i]["PERSON_ID"],
			            LAST_SAN_YN: "Y",
			        };
				} else {
			        delItem = {
			            APPR_STAP_NO: String(i+1),
			            APPR_ID : ApprovalLine,
						REG_LOGIN_NM : REG_LOGIN_NM,
						REG_PERSON_ID : REG_PERSON_ID,
			            APPROVAL_ROLE: Right_rows[i]["APPROVAL_ROLE"],
			            SAN_STS : "0",
		            	SAN_DATE : '',
		            	SAN_TIME : '',
			            SAN_LOGIN_NM: Right_rows[i]["LOGIN_NM"],
			            SAN_PERSON_ID: Right_rows[i]["PERSON_ID"],
			            LAST_SAN_YN: "N",
			        };				
				}			
				
	 	    	delItems.push(delItem);
				      	
		  	}		
		  	
			var delItems2: { PAY_REQ_NO: string; }[] = [];
			// @ts-ignore
			var delItem2:  { PAY_REQ_NO: string; } = {};
			
			for (var i = 0; i < Main_rows.length; i++) {
				if ( Main_rows[i]["chk"] ===  1){
			        delItem2 = {
			            PAY_REQ_NO: Main_rows[i]["PAY_REQ_NO"],
					}
					delItems2.push(delItem2);
				}
			}

			const response:any = await CommonUtil.execute({
				url:"adm_7000_c007",
				data: { 
					"REC1" : delItems,
					"REC2" : delItems2,
					"REG_LOGIN_NM" : REG_LOGIN_NM,
					"REG_PERSON_ID" : REG_PERSON_ID,
					"REG_TIME" : DateUtil.toDateFormat(newEndDate, "HHmmss"),
					"MAX_LINE_NO" : vMAX_LINE_NO,
					"MEMO" : MEMO,
				}
			})
	    	.then((response: any) => {
				UIUtils.alert("결재등록이 완료되었습니다.").then();
				onClose();
				onClickSearch('search');
				
	    	}).catch((error) => {
	        	CommonUtil.showAxiosError(error);
	        	return;
	        	
	    	});	 			        

		}
		
	}
	
/*		
	const handleSelect_modal = (e) => {
		if(e.target.name === 'divCd'){
			setDivCd(e.taget.value);
	    }
	};
*/
	const activeEnter_modal = (e) => {
		if(e.key === "Enter") {
			onClickSearch_modal();
		}
	}

	const rowAdd = (value) => {
		/** 행 추가 전에 중복 데이터 확인 처리 */
		//@ts-ignore
		if(RightSheet.getTotalRowCount() > 0){
			//@ts-ignore
			if(RightSheet.getTotalRowCount() > 6){
				UIUtils.alert('최대 7명까지만 결재순위에 등록할 수 있습니다.').then();
				//evtParam.sheet.showMessageTime(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다.', 800);
				return;						
			}			
			//@ts-ignore
			var Rows = RightSheet.getDataRows(); //우측 시트값 전체 데이터 조회
			//@ts-ignore
            var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
            
			for(var i=0; i<Rows.length; i++){
				if(fRows.LOGIN_NM === Rows[i].LOGIN_NM){
					UIUtils.alert("동일한 ID가 존재합니다.").then();
					return;
				}
			}
		}
		//@ts-ignore
		var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
		fRows.APPROVAL_ROLE = value;
		//@ts-ignore
		RightSheet.copyRow({row: fRows});
		//@ts-ignore
		RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		//@ts-ignore
		LeftSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
	} 	
		    	
	//결재자 위로
	const rowMoveUp = (e) => {

		// 선택된 행 객체를 얻음.
		//@ts-ignore
		var crow = RightSheet.getFocusedRow();
		if (crow) {
			//@ts-ignore
			var nrow = RightSheet.getPrevRow(crow);
			// index 기준 Row객체 얻기
			if(nrow != null){
				//@ts-ignore
				RightSheet.moveRow({row:crow, next:nrow , render:1});
				//@ts-ignore
				RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
			}

		}else{
			//@ts-ignore
			RightSheet.showMessageTime('선택된 셀이 없습니다.', 1500);
		}
	}

	//결재자 아래로
	const rowMoveDown = (e) => {
		// 선택된 행 객체를 얻음.
		//@ts-ignore
		var crow = RightSheet.getFocusedRow();
		if (crow) {
			//@ts-ignore
			var nrow = RightSheet.getNextRow(crow);
			if(nrow !=null){
				//@ts-ignore
				RightSheet.moveRow({row:nrow, next:crow , render:1});
				//@ts-ignore
				RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
			}

		}else{
			//@ts-ignore
			RightSheet.showMessageTime('선택된 셀이 없습니다.', 1500);
		}
	}
			    
	const rowDel = (e) => {
		//@ts-ignore
		RightSheet.removeRow({row:RightSheet.getFocusedRow()});
		
		//@ts-ignore
		RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.

	} 
	

    async function onAfterOpen() {
        ib_modal.create();
		
	}
	
	async function onClose() {
		setSAN_NM('');
		valueChangedApprLine_modal('');
		setMEMO('');
		setSearchText('');
	  	setModalIsOpen(false);
	  	// @ts-ignore
	  	IBSheet.LeftSheet.dispose();
	  	// @ts-ignore
	  	IBSheet.RightSheet.dispose();
		
	}    
		
 	const handleChange = (event) => {
		setMEMO(event.target.value);
	};
			
    	
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={3}  lnbD2Idx={2}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 신청 현황</h1>
					<div className="sf sf-3col">
						<div className="inner">
							<div className="sf-item sf-m-1-4"> {/* [M.20240522] */} 
								<p className="sf-key">지급기간선택</p>
								<div className="sf-value">
									<div className="hz-root hz-left hz-gap8">
									    <div className="hz-item sl sl-md w120">
										<UISelect
								        	className=""
								        	//firstName={"sel"}
								        	value={SEARCH_DATE_OPTION}
											defaultIndex ={0}
								        	valueChanged={(value) => setSEARCH_DATE_OPTION(value)}
								        	codeData={[
												{ code: 'PAY_REG_DATE', name: '지급신청일자' },
												{ code: 'PAY_COMPL_DATE', name: '집행완료일자' }
											]}
								      	/>
										</div>
										<div className="hz-item hz-root hz-gap5">
												<UIDatePicker className="hz-item" value={StartDate} valueChanged={(value) => setStartDate(value)}/>
												<span className="hz-item">~</span>
												<UIDatePicker className="hz-item" value={EndDate} valueChanged={(value) => setEndDate(value)}/>
										</div>
										<div className="hz-item hz-root hz-gap5">
											<button className="bt" data-color={dateNum === 1 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(30); setDateNum(1);}}>이전1개월</button>
											<button className="bt" data-color={dateNum === 2 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(90); setDateNum(2);}}>이전3개월</button>
											<button className="bt" data-color={dateNum === 3 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(180); setDateNum(3);}}>이전6개월</button>
											<button className="bt" data-color={dateNum === 4 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(365); setDateNum(4);}}>이전1년</button>
										</div>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">출연사업</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect
								        	className=""
								        	firstName={"all"}
								        	value={BIZ_CD}
								        	valueChanged={(value) => setBIZ_CD(value)}
								        	codeData={BIZ_SHORT_NM}
								      	/>	
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">진행상태</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect
								        	className=""
								        	firstName={"all"}
								        	value={PAY_REQ_STS_CD} 
								        	valueChanged={(value) => SetPAY_REQ_STS_CD(value)}
								        	codeData={codeDataStore.get("[PRSC]")}
								      	/>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">제출여부</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect
								        	className=""
								        	firstName={"all"}
								        	value={SUB_YN}
								        	valueChanged={(value) => setSUB_YN(value)}
								        	codeData={[
												{ code: 'Y', name: '제출' },
												{ code: 'N', name: '미제출' },
											]}
								      	/>	
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">과제명</p>
								<div className="sf-value">
										<UIInput className={'tf tf-md w100p'} value={TSK_NM} placeholder={'과제명을 입력하세요.'} readOnly={false} valueChanged={(value) => setTSK_NM(value)} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">조회조건</p>
								<div className="sf-value">
									<div className="hz-root hz-gap8">
										<div className="hz-item sl sl-md w120">
										<UISelect
								        	className=""
								        	firstName={"sel"}
								        	value={SEARCH}
								        	valueChanged={(value) => setSEARCH(value)}
								        	codeData={[
												{ code: 'CORP_NM', name: '출연기업명' },
												{ code: 'PERSON_NM', name: '담당자' },
												{ code: 'PAY_REQ_NO', name: '지급신청번호' },
											]}
								      	/>
										</div>
										<UIInput className={'hz-item hz-fg tf tf-md'} value={SEARCH_VALUE} placeholder={'검색어를 입력하세요.'} readOnly={false} valueChanged={(value) => setSEARCH_VALUE(value)} onKeyEnter={(e) => activeEnter(e)}/>
									</div>

								</div>
							</div>
						</div>
					</div>
					<div className="hz-root hz-center mb30">
						<button className="bt" data-color="pri" data-size="md"  type="button" onClick={()=> onClickSearch('search')}>조회</button>
					</div>

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="pri-o" size="sm" onClick={()=>onClickApprOpen()}>결재상신</Button>
							<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt} onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>

					<div className="ibsheet" id='tb_cfms_pay_req'></div>
					<div id="pageNavi" className="pg"></div>
					
				</main>
			</div>
			{/* modal - 7000 */}
			<ModalPopup
				open={modalIsOpen}
				title="결재선"
				size="xlg"
				onClose={() => onClose()}
				onAfterOpen={() => onAfterOpen()}
			>
				<div className="modal-con">

					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">결재선</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w400">
										<div className="hz-item hz-fg sl sl-md">
											<UISelect
									        	className=""
									        	firstName={"sel"}
									        	value={ApprovalLine}
									        	valueChanged={(value) => valueChangedApprLine_modal(value)}
									        	codeData={ApprovalLine_S}
									      	/>	
										</div>
										<Button color="gray-o" size="md" onClick={()=>onClickDelete_modal()}>삭제</Button>
									</div>

								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">결재선명</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w400">
										<UIInput type="text" className={'tf tf-md w100p'} value={SAN_NM} placeholder={''} readOnly={false} valueChanged={(value) => setSAN_NM(value)}/>
										<Button color="pri-o2" size="md" onClick={()=>onClickSave_modal()}>저장</Button>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">결재선</p>
								<div className="fo-value">
								
									<div className="approval-gen">
										<div className="approval-gen-member">
											<div className="box">
												<div className="hz-root hz-left hz-gap5 mb8">
													<div className="sl sl-sm">
														<UISelect
												        	className=""
												        	firstName={"sel"}
												        	value={divCd}
												        	valueChanged={(value) => setDivCd(value)}
												        	codeData={[
																{ code: '01', name: '이름' },
																{ code: '02', name: '아이디' },
															]}												        	
												      	/>														
													</div>
													<UIInput 
														className={'tf tf-sm w200'} 
														value={searchText} 
														placeholder={''} 
														valueChanged={(value) => setSearchText(value)} 
														onKeyEnter={(e) => activeEnter_modal(e)}
													/>
													<Button color="pri" size="sm" onClick={()=>onClickSearch_modal()}>검색</Button>
												</div>
												<div id ="LeftSheetDiv" className="ibsheet" ></div>
											</div>
										</div>
										<div className="approval-ctr">
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd(1)}>검토자</button>
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd(2)}>협조자</button>
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd(3)}>감사자</button>
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd(4)}>결재자</button>
										</div>
										<div className="approval-gen-selected">
											<div className="box">
												<div className="hz-root hz-sb hz-bottom mb8">
													<h2 className="hz-item tx tx-bd2">결재순위</h2>
													<div className="hz-item hz-root hz-right hz-gap5">
														<Button color="gray-o" size="sm" onClick={rowDel}>삭제</Button>
														<button className="hz-item bt bt-gray-o bt-down" type="button" onClick={rowMoveDown}>아래로</button>																						
														<button className="hz-item bt bt-gray-o bt-up" type="button" onClick={rowMoveUp}>위로</button>
													</div>																			
												</div>												
												<div id="RightSheetDiv" className="ibsheet"></div>
											</div>
											<div className="info">
													<p className="info-tit">안내</p>
													<ul className="info-list">
														<li>위에서부터 아래로 결재순서가 진행됩니다.</li>
														<li>최종결재자의 한도금액이 설정되지 않아 결재상신이 안되는 경우는 관리자에게 문의하시기 바랍니다.</li>
													</ul>
											</div>
										</div>
									</div>

								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className="ta h50 w100p">
										<textarea  className="ta-ip" placeholder="" value={MEMO} onChange={handleChange}></textarea>
									</div>
								</div>
							</div>														
							
						</div>
					</form>

				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => onClose()} >취소</Button>
						<Button color='pri' size="md" onClick={()=>onClickApprRegist_modal()}>결재상신</Button>
					</div>
				</div>	
			</ModalPopup>					
		</PageContainer>
	);
}
export default ContentsContainer;